import delegation from './delegation';
export * from './delegation';

export default { delegation: delegation };
